<template>
    <div class="profileview">
            <ul class="mt-3">
                <li><strong>Namn:</strong> {{profile.firstName}} {{profile.lastName}} ({{profile.slug}})</li>
                <li><strong>Ort:</strong> {{profile.city}}</li>
                <li><strong>Titel:</strong> {{profile.title}}</li>
                <li><strong>Hemsida:</strong> {{profile.homepage}}</li>
            </ul>
            <div class="mt-5" v-if="profile.accountId">
                <p>Connected to Stripe</p>
            </div>
            <div class="mt-5 connect" v-if="!profile.accountId">
                <a v-bind:href="connectUrl" class="stripe-connect"><span>Anslut med Stripe</span></a>
            </div>
    </div>
</template>

<script>
import faunadb, { query as q } from "faunadb";

export default {
    name: "ProfileViewer",
    data: () => ({
        profile: {},
        connectUrl: ""
    }),
    methods: {
    },
    async created() {
        const token = this.$store.state.token;
        const client = new faunadb.Client({ secret: token });
        let profile = await client.query(q.Call('getProfile'));
        this.$data.profile = profile.data;
        const urlRes = await this.$http.get("/api/connect/link");
        this.$data.connectUrl = urlRes.data.url;
    }
    
}
</script>

<style scoped>
@import "~@/assets/css/stripe.css";
</style>